export const CLEAR_ALL_REDUCERS_DATA = 'CLEAR_ALL_REDUCERS_DATA';

export const stateActions = {
  clearAllStoreData: () => ({
    type: CLEAR_ALL_REDUCERS_DATA
  })
};
